import React from 'react';
import { useGeoJSONImporterPresenter, GeoJSONLayer } from './GeoJSONImporterPresenter';
import { GeoJSONImporterView } from './GeoJSONImporterView';
import { GridElement, Connection } from '../../types';

interface GeoJSONImporterProps {
  layers: GeoJSONLayer[];
  onLayerAdd: (layer: GeoJSONLayer) => void;
  onLayerRemove: (layerId: string) => void;
  onLayerUpdate: (layerId: string, updates: Partial<GeoJSONLayer>) => void;
  onElementsAdd?: (elements: GridElement[]) => void;
  onConnectionsAdd?: (connections: Connection[]) => void;
  existingElements?: GridElement[];
  mapBounds?: {
    minLat: number;
    maxLat: number;
    minLng: number;
    maxLng: number;
  };
}

export const GeoJSONImporter: React.FC<GeoJSONImporterProps> = ({
  layers,
  onLayerAdd,
  onLayerRemove,
  onLayerUpdate,
  onElementsAdd,
  onConnectionsAdd,
  existingElements = [],
  mapBounds = { minLat: 48.86, maxLat: 48.88, minLng: 2.29, maxLng: 2.31 }
}) => {
  const { state, actions, fileInputRef, extractPoints, extractLineStrings } = useGeoJSONImporterPresenter({
    onLayerAdd,
    onElementsAdd,
    onConnectionsAdd,
    existingElements,
    mapBounds
  });

  return (
    <GeoJSONImporterView
      state={state}
      actions={actions}
      fileInputRef={fileInputRef}
      extractPoints={extractPoints}
      extractLineStrings={extractLineStrings}
      layers={layers}
      onLayerRemove={onLayerRemove}
      onLayerUpdate={onLayerUpdate}
    />
  );
};

// Export the GeoJSONLayer type for use in other components
export type { GeoJSONLayer };
